import { useEffect } from 'react';
import type { RefObject } from 'react';

/**
 * Хук для обноружения кликов вне элемента.
 * @param ref Ссылка на объект.
 * @param callback Функция, которая срабатывает если клик был не по объекту.
 * @param needExecute Функция для выполнения хука только на активном элементе.
 */
export const useOutsideClick = (
  ref: RefObject<HTMLInputElement>,
  callback: () => void,
  needExecute: () => boolean,
): void => {
  const handleClick = (e: Event) => {
    if (ref.current) {
      if (e.target instanceof HTMLElement || e.target instanceof SVGElement) {
        if (!ref.current.contains(e.target) && needExecute()) {
          callback();
        }
      }
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  });
};
